import { useRedrawAt } from "../components/useRedrawAt";
import { useStore } from "../store";
import { EVENT_MS } from "./tableToast";

/** An event toast lasts three seconds: the table looks again when a new one lands and when its time is up. */
export function useToastClock(): void {
  const eventsAt = useStore((state) => state.eventsAt);
  useRedrawAt(eventsAt === 0 ? null : eventsAt + EVENT_MS + 20);
}
